import '@/index.scss';
import 'antd/dist/antd.css';

import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

import { UserContextProvider } from './context/user';

import { DefaultLayout } from '@/layout'
import { getNavUrl } from './utils/navigation';

import { PageHome } from '@/pages/home'

import { PageMy } from '@/pages/my';
// import { PageProduct } from '@/pages/product';
import { PageSearch } from '@/pages/search';

import { PageManage } from '@/pages/manage';
import { PageApple } from '@/pages/item/apple';
import { PageStrawberry } from '@/pages/item/strawberry';
import { PageItem } from '@/pages/item';
import { PageAudience } from '@/pages/audience';
import { PageParameter } from '@/pages/parameter';
import { PageCart } from '@/pages/cart'
import { PageAbout } from '@/pages/about'
import { PageEventSummerSale } from '@/pages/event/summer_sale'
import { PageFB } from '@/pages/fb'
import { PageSignUp } from '@/pages/sign_up'
import { PageLogin } from '@/pages/login'
import { PagePurchase } from '@/pages/purchase'
import { PageInstall } from '@/pages/install'
import { PageDemo } from '@/pages/demo'
import { PageUser } from '@/pages/user'
import { PageShop } from '@/pages/shop'
import { PageDocsEcommerce } from '@/pages/docs/ecommerce'
import { PageDocsEcommerceDev } from '@/pages/docs/ecommerce_dev'
import { PageDocsPredictive } from './pages/docs/predictive';
import { PageDocsUserId } from './pages/docs/user_id';
import { PageDocsEvent } from './pages/docs/event';
import { PageDocsRemoteConfig } from './pages/docs/remote_config';
import { PageDocsCloudMessaging } from './pages/docs/cloud_messaging';
import { PageApk } from '@/pages/apk'
import { PageUpdate } from '@/pages/update';

import { WithStudyProperty } from '@/pages/_withStudyProperty';

const App = () => {
  return (
    <UserContextProvider>
      <Router>
        <DefaultLayout>
          <Switch>
            <Route path={getNavUrl('/demo')}>
              <PageDemo />
            </Route>
            <Route path={getNavUrl('/apk')}>
              <PageApk />
            </Route>
            <Route path={getNavUrl('/install')}>
              <PageInstall />
            </Route>
            <Route path={getNavUrl('/docs/ecommerce')}>
              <PageDocsEcommerce />
            </Route>
            <Route path={getNavUrl('/docs/ecommerce_dev')}>
              <PageDocsEcommerceDev />
            </Route>
            <Route path={getNavUrl('/docs/predictive')}>
              <PageDocsPredictive />
            </Route>
            <Route path={getNavUrl('/docs/user_id')}>
              <PageDocsUserId />
            </Route>
            <Route path={getNavUrl('/docs/event')}>
              <PageDocsEvent />
            </Route>
            <Route path={getNavUrl('/docs/remote_config')}>
              <PageDocsRemoteConfig />
            </Route>
            <Route path={getNavUrl('/docs/cloud_messaging')}>
              <PageDocsCloudMessaging />
            </Route>
            <Route path={getNavUrl('/login')}>
              <WithStudyProperty require="ga4">
                <PageLogin />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/shop')}>
              <WithStudyProperty require="ga4">
                <PageShop />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/purchase')}>
              <WithStudyProperty require="ga4">
                <PagePurchase />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/sign_up')}>
              <WithStudyProperty require="ga4">
                <PageSignUp />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/fb')}>
              <WithStudyProperty require="ga4">
                <PageFB />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/event/summer_sale')}>
              <WithStudyProperty require="ga4">
                <PageEventSummerSale />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/about')}>
              <WithStudyProperty require="ga4">
                <PageAbout />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/manage')}>
              <PageManage />
            </Route>
            <Route path={getNavUrl('/update')}>
              <PageUpdate />
            </Route>
            <Route path={getNavUrl('/my')}>
              <WithStudyProperty require="ga4">
                <PageMy />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/search')}>
              <WithStudyProperty require="ga4">
                <PageSearch />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/parameter')}>
              <WithStudyProperty require="ga4">
                <PageParameter />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/item/apple')}>
              <WithStudyProperty require="ga4" passaway={true}>
                <PageApple />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/item/strawberry')}>
              <WithStudyProperty require="ga4" passaway={true}>
                <PageStrawberry />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/user')}>
              <WithStudyProperty require="ga4" passaway={true}>
                <PageUser />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/audience')}>
              <WithStudyProperty require="ga4">
                <PageAudience />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/item')}>
              <WithStudyProperty require="ga4">
                <PageItem />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/cart')}>
              <WithStudyProperty require="ga4">
                <PageCart />
              </WithStudyProperty>
            </Route>
            <Route path={getNavUrl('/')}>
              <PageHome />
            </Route>
          </Switch>
        </DefaultLayout>
      </Router>
    </UserContextProvider>
  );
}


export default App;